import { Switch } from "@/components/ui/switch";

const TUNES = [
  { key: "off", label: "Off", hint: "Your notes exactly as you sang them" },
  { key: "natural", label: "Natural", hint: "Gently pulls notes in tune, keeps your vibrato and feel" },
  { key: "tight", label: "Tight", hint: "Locks every note onto pitch — a polished, modern sound" },
];

/** Noise cleanup + pitch correction, applied on the server when the new version is made. */
export default function TouchUps({ settings, onChange, projectKey, disabled }) {
  return (
    <div className="space-y-6">
      <label className="flex cursor-pointer items-start gap-3">
        <Switch data-testid="replace-denoise-toggle" checked={settings.denoise} onCheckedChange={(v) => onChange({ denoise: v })} disabled={disabled} className="mt-0.5 data-[state=checked]:bg-amber-400 data-[state=unchecked]:bg-white/15" />
        <span>
          <span className="block font-display text-[14px] font-semibold">Clean background noise</span>
          <span className="block text-[12px] text-white/50">Removes room hiss, hum and fan noise from your take.</span>
        </span>
      </label>
      <div>
        <p className="mb-2 font-mono text-[10px] uppercase tracking-[0.18em] text-white/55">Pitch correction</p>
        <div role="radiogroup" className="grid gap-2 sm:grid-cols-3">
          {TUNES.map((t) => (
            <button key={t.key} type="button" role="radio" aria-checked={settings.tune === t.key} data-testid={`replace-tune-${t.key}`} disabled={disabled}
              onClick={() => onChange({ tune: t.key })}
              className={`rounded-2xl border px-3.5 py-3 text-left transition-colors duration-200 disabled:opacity-50 ${settings.tune === t.key ? "border-amber-300/60 bg-amber-500/15 text-white" : "border-white/10 bg-white/[0.03] text-white/70 hover:bg-white/[0.07]"}`}>
              <p className="font-display text-[13px] font-semibold">{t.label}</p>
              <p className="mt-0.5 text-[11px] leading-snug text-white/50">{t.hint}</p>
            </button>
          ))}
        </div>
        {settings.tune !== "off" ? (
          <label className="mt-4 block max-w-sm">
            <span className="mb-1 block font-mono text-[10px] uppercase tracking-[0.16em] text-white/55">Tune to</span>
            <select data-testid="replace-scale-select" value={settings.scale} disabled={disabled} onChange={(e) => onChange({ scale: e.target.value })}
              className="w-full rounded-xl border border-white/10 bg-black/50 px-3 py-2 text-sm text-white focus:border-amber-300/60 focus:outline-none">
              {projectKey ? <option value="key">The song's key · {projectKey}</option> : null}
              <option value="chromatic">Every note (safest)</option>
            </select>
          </label>
        ) : null}
      </div>
    </div>
  );
}
